import { Outlet } from "react-router-dom";
import { AdminProvider } from "./AdminContext";
import { AuthProvider } from "./AuthContext";
import { DialogProvider } from "./DialogContext";
import { OnboardingProvider } from "./OnboardingContext";
import { ToastProvider } from "./ToastContext";

export const AppProvider = () => {
    return (
        <ToastProvider>
            <DialogProvider>
                <AuthProvider>
                    <OnboardingProvider>
                        <AdminProvider>
                            <Outlet />
                        </AdminProvider>
                    </OnboardingProvider>
                </AuthProvider>
            </DialogProvider>
        </ToastProvider>
    )
}